/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PendingUser } from './PendingUser';
import {
    PendingUserFromJSON,
    PendingUserFromJSONTyped,
    PendingUserToJSON,
} from './PendingUser';

/**
 * 
 * @export
 * @interface ClassPendingEnrollmentResponse
 */
export interface ClassPendingEnrollmentResponse {
    /**
     * 
     * @type {string}
     * @memberof ClassPendingEnrollmentResponse
     */
    classId: string;
    /**
     * 
     * @type {Array<PendingUser>}
     * @memberof ClassPendingEnrollmentResponse
     */
    pendingUsers: Array<PendingUser>;
}

/**
 * Check if a given object implements the ClassPendingEnrollmentResponse interface.
 */
export function instanceOfClassPendingEnrollmentResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "classId" in value;
    isInstance = isInstance && "pendingUsers" in value;

    return isInstance;
}

export function ClassPendingEnrollmentResponseFromJSON(json: any): ClassPendingEnrollmentResponse {
    return ClassPendingEnrollmentResponseFromJSONTyped(json, false);
}

export function ClassPendingEnrollmentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClassPendingEnrollmentResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'classId': json['classId'],
        'pendingUsers': ((json['pendingUsers'] as Array<any>).map(PendingUserFromJSON)),
    };
}

export function ClassPendingEnrollmentResponseToJSON(value?: ClassPendingEnrollmentResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'classId': value.classId,
        'pendingUsers': ((value.pendingUsers as Array<any>).map(PendingUserToJSON)),
    };
}

